import { Injectable } from '@angular/core';

import { TreeNode } from '../../models/interfaces/tree-node.interface';


@Injectable()
export class TreeService {

  countCheckeds(treeNode: TreeNode): number {
    return treeNode.children ? treeNode.children?.filter(n => n.isChecked).length : 0
  }

  formatSelectedsText(treeNode: TreeNode): string {
    const countCheckeds = treeNode.children?.filter(n => n.isChecked).length
    let concatNames: string = ''

    if (countCheckeds && countCheckeds > 0) {
      const checkeds = treeNode.children?.filter(n => n.isChecked)
      if (checkeds) {
        checkeds.forEach(node => {
          concatNames += node.name?.concat(', ')
        });
      }
    }

    if (countCheckeds && concatNames.length > 0) {
      if (concatNames.length > 20) {
        const firstName = concatNames.split(',')[0]

        if (countCheckeds > 1)
          return firstName + ` + ${countCheckeds - 1}`
        else
          return firstName
      }
      else {
        //replace last comma
        return concatNames.replace(/,\s*$/, '')
      }
    }
    else
      return concatNames.replace(/,\s*$/, '')
  }

  hasCheckedItems(treeNode: TreeNode): boolean {
    const countCheckeds = treeNode.children?.filter(n => n.isChecked).length
    if (countCheckeds)
      return countCheckeds > 0
    else
      return false
  }
}
